<template>
  <LayoutEntity :navigation-items="[]">
    <template #subheading></template>
    <template #headingNew>New {{ entityLabel }} Access Request</template>
    <template #default>
      <FormKit
        type="form"
        id="theFormId"
        :value="accessRequest"
        v-model="accessRequest"
        @submit="handleSubmit"
        :actions="false"
        autocomplete="off"
      >
        <template #default="{ state: formState }">
          <div class="pb-5 sm:flex-1 sm:overflow-auto">
            <FormSection>
              <template #sectionName>Access Request Details</template>
              <template #sectionDescription>
                <p>
                  If you need to submit distributor reports and product list updates, please request access to
                  distributor to get started.
                </p>
                <br />
                <p>
                  You will be notified by the Deposit Beverage Container Program after your request is reviewed and
                  access is granted to your distributor.
                </p>
              </template>
              <template #default>
                <FormKit
                  name="requestText"
                  type="text"
                  :label="requestTextLabel"
                  validation="required:trim|length:0,255"
                />
              </template>
            </FormSection>
          </div>
          <FormActions
            :save-action="saveAction"
            :cancel-action="cancelAction"
            :form-state="formState"
            save-label="Submit"
          ></FormActions
        ></template>
      </FormKit>
    </template>
  </LayoutEntity>
</template>

<script lang="ts">
import { routeNames } from "@/routes";
import { type AccessRequest, type AccessRequestResponse } from "@/views/accessRequest/accessRequest";
import { createAccessRequest } from "@/views/accessRequest/accessRequestApi";
import { FormKit, submitForm } from "@formkit/vue";
import { FormActions, FormSection } from "@modernary/mui/components/form";
import { LayoutEntity } from "@modernary/mui/components/layouts";
import { useApi } from "@modernary/mui/utils/api";
import { routeCancelAction } from "@modernary/mui/utils/helpers";
import { computed, defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "AccessRequest",
  components: {
    LayoutEntity,
    FormKit,
    FormSection,
    FormActions,
  },
  props: {
    entityName: {
      type: String,
      required: true,
    },
    entityLabel: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const accessRequest = ref<AccessRequest>({ entityName: "", requestText: "" });

    const requestTextLabel = computed(() => {
      return `${props.entityLabel} Name`;
    });

    const { exec: execCreateAccessRequest, isStatusPending } = useApi<AccessRequest, AccessRequestResponse>(
      createAccessRequest,
      {
        responseAdapter: async (response) => {
          // Things get awkward when our API returns a very different type than we're creating.
          const result = response.data as unknown as AccessRequestResponse;
          if (result.wasRequestSubmitted) {
            cancelAction();
          }

          return result;
        },
      },
    );

    const handleSubmit = async (data: AccessRequest) => {
      data.entityName = props.entityName;

      return execCreateAccessRequest(data);
    };

    const saveAction = function () {
      return submitForm("theFormId");
    };

    const cancelAction = function () {
      routeCancelAction(router, routeNames.home);
    };

    return {
      accessRequest,
      handleSubmit,
      saveAction,
      cancelAction,
      requestTextLabel,
    };
  },
});
</script>
